import React, { useState, useEffect } from "react";

// Style //
import "./Induction.css";

// Images //
import { icons } from "../../assets/index";

// Components //
import {
  PageHeading,
  ButtonComp,
  TableRowLoader,
  DropDown,
  SearchBar,
} from "../../common/components/index";
import Modal from "react-bootstrap/Modal";
import Pagination from "rc-pagination";

// API's //
import { deleteDocumentApi, deleteInductionVideoApi, downloadSiteDocumentApi, getDocumentationApi } from "../../api/inductionAndDocumentation";

// Hooks //
import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

// Actions //
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../redux/actions/utilsActions";
import { Accordion, Button } from "react-bootstrap";

const Induction = () => {
  // Hooks //
  const navigate = useNavigate();
  const location = useLocation();
  const isArchived = location.pathname.endsWith('archived');
  const { loading } = useSelector((state) => state.utils);
  const { userToken } = useSelector((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams({ page: 1 });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState("");
  const [limitPerPage, setlimitPerPage] = useState(5);
  const [modalShow, setModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const [documentsData, setDocumentsData] = useState([]);
  const [inductionVideo, setInductionVideo] = useState('')
  const [downloadPath, setDownloadPath] = useState();
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    getDocumentsData({
      page: searchParams.get("page") || 1,
      limit: limitPerPage,
    });
    setCurrentPage(Number(searchParams.get("page")) || 1);
  }, [currentPage, limitPerPage, location.pathname]);

  // API Calls //
  const getDocumentsData = async (value) => {
    try {
      dispatch(requestSent());
      const data = await getDocumentationApi(userToken, {
        page: value.page,
        limit: value.limit,
        name: value.name || "",
        is_archived: isArchived
      });
      setInductionVideo(data.induction_video);
      setDocumentsData(data.data.rows);
      setDownloadPath(data.public_path);
      setTotalCount(data.data.count);
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  };

  const deleteInductionVideo = async () => {
    try {
      dispatch(requestSent());
      await deleteInductionVideoApi(userToken);
      setInductionVideo('');
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  };

  const downloadSiteDocuments = async (siteId, documentId) => {
    try {
      dispatch(requestSent());      
      const data = await downloadSiteDocumentApi(userToken, {
        site_id: siteId,
        document_id: documentId
      });

      const fileurl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = fileurl;

      if(documentId) {
        link.setAttribute('download', `document.pdf`);
      } else {
        link.setAttribute('download', `siteDocuments.zip`);
      }
      document.body.appendChild(link);

      link.click();

      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  };

  // Handlers //
  const updatePageHandler = (p) => {
    setSearchParams({ page: p });
    setCurrentPage(p);
  };

  const handleShow = (value) => {
    setlimitPerPage(value);
    setSearchParams({ page: 1, show: value });
  };

  const handleSearch = async (value) => {
    setSearchValue(value);
    getDocumentsData({
      name: value,
      page: 1,
      limit: limitPerPage,
    });
  };

  // On Page Components //
  const CustomModal = () => {
    const deleteDocument = async () => {
      setModalShow(false)
      try {
        if (itemToDelete === 'video') {
          return deleteInductionVideo()
        }
        dispatch(requestSent());
        await deleteDocumentApi(userToken, itemToDelete);
        await getDocumentsData({
          page: searchParams.get("page"),
          limit: limitPerPage,
        })
        dispatch(responseRecived());
      } catch (error) {
        dispatch(receivedError(error));
      }
    };

    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
      >
        <Modal.Body>
          <div className="allert_img_cont">
            <h2>Are you sure you want to delete this document ?</h2>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            className="btn_style"
            variant="secondary"
            onClick={() => setModalShow(false)}
          >
            Cancel
          </Button>
          <Button
            className="orange_btn btn_style"
            onClick={deleteDocument}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const toggleArchivedReinstatedSites = () => {
    setSearchParams({ page: 1, show: 10 })
    if (isArchived) {
      navigate("/induction/")
    } else {
      navigate("/induction/archived")
    }
  }

  return (
    <div id="induction">
      <CustomModal />
      <PageHeading title={"Induction & Documents"} />
      <div className="right-sec_cont">
        <div className="your_induction">
          <img src={icons.induction} alt="" />
          <div className="txt">
            <h3>Your Induction</h3>
            <p>
              Add required documents here for sub-contractors to sign, and also
              upload an induction video specific to your company that you want
              sub-contractors to watch before coming to site.
            </p>
          </div>
        </div>
        <div className="filter_cont justify-content-between align-items-center mt-3">
          <div className="d-flex justify-content-between">
            <DropDown
              label={"Show"}
              listItems={["2", "8", "10", "15", "20", "25"]}
              onSelect={handleShow}
              value={limitPerPage}
            />
            <SearchBar
              onChange={handleSearch}
              value={searchValue}
              type={"text"}
              width={"80%"}
              marginLeft={"25px"}
              placeholder={"Search Sub-Contractor"}
            />
          </div>

          <ButtonComp
            onClick={() => navigate("/induction/add-induction")}
            title={"Upload Induction Video"}
            width={"25%"}
            bgColor={"white"}
            style={{
              color: "black",
              marginLeft: 50,
              border: "1.5px solid black",
            }}
          />
          <ButtonComp
            onClick={() => navigate("/induction/add-documents")}
            title={"Add Documents"}
            width={"25%"}
          />
        </div>

        {loading ? (
          <TableRowLoader limit={8} />
        ) : (
          <>
            <Accordion style={{ marginBottom: '1rem' }}>
              {/* Induction Video Accordian */}
              {
                !isArchived && inductionVideo ? <Accordion.Item eventKey={'inductionVideo'}>
                  <Accordion.Header>
                    <div className="accordion_header">
                      <h2>Induction Video</h2>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="induction_accordion_row">
                      <div className="induction_accordion_row_left">
                        <img
                          className="table_icon"
                          src={icons.Documents}
                          alt="document_logo"
                          onClick={() => {
                            window.location.href = inductionVideo;
                          }}
                        />
                        <p>Induction Video</p>
                      </div>

                      <button style={{ background: 'transparent' }} onClick={() => {
                        setItemToDelete('video')
                        setModalShow(true)
                      }}>
                        <i class="fa fa-trash fa-xl" aria-hidden="true" style={{ cursor: 'pointer', color: 'var(--primary_color)' }}></i>
                      </button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item> : null
              }

              {/* Sites Docs Accordian */}
              {
                documentsData.length ? documentsData.map(site => {
                  return (
                    <Accordion.Item eventKey={site} key={site.id}>
                      <Accordion.Header >
                        <div className="accordion_header">
                          <h2>{site.reference} {site.name}</h2>
                          <button onClick={() => downloadSiteDocuments(site.id)}>
                            <i class="fa fa-download fa-xl" aria-hidden="true" style={{ cursor: 'pointer', color: 'var(--primary_color)' }}></i>
                          </button>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {
                          site.ContractorSiteDocuments.map(doc => {
                            return (
                              <div className="induction_accordion_row">
                                <div className="induction_accordion_row_left">
                                  <img
                                    className="table_icon"
                                    src={icons.Documents}
                                    alt="document_logo"
                                    onClick={() => {
                                      if (doc.image) {
                                        // If doc has an image, navigate to the specified download path
                                        window.location.href = `${downloadPath}${doc.image}`;
                                      }
                                    }}
                                  />
                                  <p>{doc.name}</p>
                                </div>

                                <div className="induction-doc-icons">
                                  <button onClick={() => {
                                    downloadSiteDocuments(undefined, doc.id)
                                  }} style={{ minWidth: '1rem' }}>
                                    <i class="fa fa-download fa-xl" aria-hidden="true" style={{ cursor: 'pointer', color: 'var(--primary_color)' }}></i>
                                  </button>

                                  <button onClick={() => {
                                    setItemToDelete(doc.id)
                                    setModalShow(true)
                                  }} style={{ minWidth: '1rem' }}>
                                    <i class="fa fa-trash fa-xl" aria-hidden="true" style={{ cursor: 'pointer', color: 'var(--primary_color)' }}></i>
                                  </button>
                                </div>

                              </div>
                            )
                          })
                        }
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                }) : !inductionVideo ? <p style={{ fontSize: '1rem', textAlign:'center' }}>No Documents Found</p> : null
              }
            </Accordion>

            <div className="pagination_cont">
              <ButtonComp
                onClick={toggleArchivedReinstatedSites}
                title={isArchived ? 'Reinstated Site/project' : "Archived Site/project"}
                width={"20%"}
                style={{ marginRight: 'auto' }}
              />
              <Pagination
                pageSize={limitPerPage}
                onChange={updatePageHandler}
                current={currentPage}
                total={totalCount}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Induction;
